import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ChartDataSets, ChartOptions } from "chart.js";
import { Color, Label } from "ng2-charts";

import { ZoneComponent } from "@/shared-module/components";
import { RadarChartDatasource } from "@/shared-module/models";
import { DialogService } from "@/shared-module/services";

@Component({
  selector: "app-radarchart",
  templateUrl: "radarchart.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class RadarChartComponent implements ZoneComponent, OnInit {
  @ViewChild("template", { static: true }) template;
  @Input() data: RadarChartDatasource;
  @Input() width: number;
  @Input() needpaddingLeft: boolean;
  @Input() isZoom: boolean;

  public chartData: ChartDataSets[] = [];
  public chartColors: Color[] = [];
  public chartLegend = true;
  public chartType = "radar";
  public chartOptions: ChartOptions = {
   legend: {
      labels: {
         generateLabels: (chart) => {
          return (chart.data.datasets || []).map((dataset, i) => ({
            text: dataset.label as string,
            fillStyle: dataset.borderColor as string,
            strokeStyle: dataset.borderColor as string,
            lineWidth: 2,
            datasetIndex: i,
          }));
        },
      },
    },
    tooltips: {
      callbacks: {
        title: (tooltipItems, chartData) => {
          const tooltipItem = tooltipItems?.[0];
          const datasetIndex = tooltipItem?.datasetIndex;
          const pointIndex = tooltipItem?.index;

          if (datasetIndex == null || pointIndex == null) {
            return "";
          }

          const measure = chartData?.labels?.[pointIndex];
          const measureLabel = Array.isArray(measure) ? measure.join(" ") : `${measure ?? ""}`;
          const serieName = chartData?.datasets?.[datasetIndex]?.label ?? "";

          if (measureLabel && serieName) {
            return `${measureLabel} - ${serieName}`;
          }

          return measureLabel || `${serieName}`;
        },
        label: (tooltipItem, data) => {
          const datasetIndex = tooltipItem.datasetIndex;
          const pointIndex = tooltipItem.index;

          if (
            datasetIndex == null ||
            pointIndex == null ||
            !this.data?.series?.[datasetIndex]?.yValues?.[pointIndex]
          ) {
            return "";
          }

          return this.data.series[datasetIndex].yValues[pointIndex].yLabel;
        },
      },
    },
    scale: {
        angleLines: {
            display: true,
            lineWidth: 1
        },
        gridLines: { 
            lineWidth: 1
        },
        ticks: {
            display: false,
            min: 0,
            max: 6
        }
    }
   };
  public chartLabels: Label[] = [];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dialogService: DialogService
  ) {}

  private getSerieStyle(isCurrentTeam: boolean) {
    return {
      borderWidth: isCurrentTeam ? 3 : 1,
      pointRadius: isCurrentTeam ? 3 : 2,
      pointHoverRadius: isCurrentTeam ? 5 : 3,
      backgroundOpacity: isCurrentTeam ? 0.35 : 0.08,
      borderOpacity: 1,
    };
  }

  zoom() {
    this.dialogService.setZoomInfo(this.data.zoomInfo);
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);

    if (this.data) {
                console.log("radar chart init with data", this.data);
                
      this.chartLabels = this.data.dimensions;;
      this.chartData = [];
      this.chartColors = [];

      this.data.series.forEach((s) => {
        const serieStyle = this.getSerieStyle(!!s.isCurrentTeam);
        let dataset = [];
        s.yValues.forEach((v) => {
          dataset.push(v.y);
        });
        console.log(s.caption);
        // tslint:disable-next-line:object-literal-shorthand
        let ds = {
          data: dataset,
          label: s.caption,
          fill: true,
          borderWidth: serieStyle.borderWidth,
          pointRadius: serieStyle.pointRadius,
          pointHoverRadius: serieStyle.pointHoverRadius,
        };
        let color = {
          backgroundColor: "rgba(" + s.color + ", " + serieStyle.backgroundOpacity + ")",
          borderColor: "rgba(" + s.color + ", " + serieStyle.borderOpacity + ")",
          pointBackgroundColor: "rgba(" + s.color + ", 1)",
          pointHoverBackgroundColor: "rgba(" + s.color + ", 1)",
        };

        this.chartData.push(ds);
        this.chartColors.push(color);
      });

    }
 }
}
